/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import circles from 'assets/images/circles.png';
import dialogIcon from 'assets/images/dialogLogo.svg';
import exploreImg from 'assets/images/exploreImg.svg';
import { Button, Input } from 'components/atoms';
import { useRequestOTP } from 'framework/api/methods';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    setPhoneNumber(location.state?.phoneNumber || '');
  }, [location]);

  const { mutate: requestOTPMutate, isLoading: requestOTPIsLoading } = useRequestOTP();

  // function to request Otp for registered / unregistered users
  const handleRequestOTP = () => {
    requestOTPMutate(
      {
        mobile: phoneNumber,
        name,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          navigate('/auth/verify-otp', {
            state: { phoneNumber, name, ref: successData?.serverRef, isNewUser: true },
          });
          notify(successData?.message || 'OTP has been sent successfully', 'success');
        },
        onError: ({ response: { data: errData } }: any) => {
          if (errData?.message) {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  return (
    <div className="flex w-full h-full overflow-hidden relative">
      <div className="w-[55%] relative backdrop-explore  justify-center items-center text-white hidden lg:flex flex-col gap-y-5">
        <div className="flex tracking-[20px] text-[3rem] font-light text-white text-shadow">
          EXPLORE
        </div>

        <img src={exploreImg} alt="welcome-img" className="w-[300px] h-[300px] z-[2]" />

        <div className="flex flex-col justify-center items-center z-[2]">
          <img src={dialogIcon} alt="dialog-icon" className="w-[100px]" />
          <div className="font-light text-xl text-white w-[70%] text-center">
            Welcome to the Dialog 3D 360 VR video platform
          </div>
        </div>
        <img src={circles} alt="welcome-img" className="w-[120px] absolute bottom-4 left-4 z-[1]" />
      </div>

      <div className="lg:rounded-l-[50px] lg:w-[50%] w-full border absolute h-full right-0 bg-[white] flex flex-col justify-center items-center">
        <div className="flex text-[50px] font-light text-[#F7941E] text-center justify-center items-center w-full">
          REGISTER
        </div>
        <div className="w-1/2 flex flex-col pt-5 gap-y-3">
          <Input
            icon="ri-user-line"
            placeholder="Username"
            appearance="gray"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Input
            icon="ri-phone-line"
            placeholder="Phone"
            appearance="gray"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
          />

          {/* Terms & Conditions Checkbox */}
          <div className="flex items-center gap-2 mt-2">
            <input
              type="checkbox"
              id="terms"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.checked)}
              className="w-4 h-4 rounded-lg border-gray-400 
               checked:bg-[#F7941E] checked:border-[#a66f2b] 
               checked:focus:ring-[#F7941E]"
              style={{
                accentColor: '#F7941E',
              }}
            />
            <label htmlFor="terms" className="text-sm text-gray-500">
              I agree to the{' '}
              <a
                href="/terms-and-conditions.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#F7941E] cursor-pointer"
              >
                Terms and Conditions
              </a>
            </label>
          </div>
        </div>

        <Button
          isRounded
          className="mt-5 !px-10"
          size="md"
          isLoading={requestOTPIsLoading}
          disabled={!name || !phoneNumber || !isAgreed}
          onClick={() => {
            if (/^07\d{8}$/.test(phoneNumber)) {
              handleRequestOTP();
            } else {
              notify('Invalid phone number', 'error');
            }
          }}
        >
          Register
        </Button>

        <Button
          appearance="link"
          className="mt-1"
          onClick={() => {
            navigate('/auth/login');
          }}
        >
          Login ?
        </Button>
      </div>
    </div>
  );
};

export default Signup;
